import React from 'react';

import AppHeader from './AppHeader';

const AppHeaderContainer = () => <AppHeader />;

export default AppHeaderContainer;
